import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationsCenterComponent } from './notifications-center.component';


const routes: Routes = [
  {path:'',component: NotificationsCenterComponent},

];
// const routes: Routes = [
//   { path: '', children:[
//     {path:'home', component: TestComponent},
//   ] },
// ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationsCenterRoutingModule { }
